import { Chip } from '@mui/material';

export type PayerConfidence = 'high' | 'medium' | 'low' | 'unresolved';

export const NEEDS_REVIEW_CONFIDENCE = new Set<string>(['low', 'unresolved']);

const CHIP_SX = { height: 20, fontSize: '0.7rem' } as const;

export function PayerConfidenceChip({ confidence }: { confidence: string }) {
  switch (confidence as PayerConfidence) {
    case 'high':
    case 'medium':
      return <Chip label="✓ Matched" color="success" size="small" sx={CHIP_SX} />;
    case 'low':
      return <Chip label="⚠ Low confidence" color="warning" size="small" sx={CHIP_SX} />;
    case 'unresolved':
      return <Chip label="✗ Not found" color="error" size="small" sx={CHIP_SX} />;
    default:
      return null;
  }
}

/**
 * Returns the worst confidence tier across all three payer tiers,
 * or null if no insurance resolution data is present.
 */
export function worstConfidence(
  primary?: string | null,
  secondary?: string | null,
  tertiary?: string | null,
): string | null {
  const TIER_RANK: Record<string, number> = {
    unresolved: 0,
    low: 1,
    medium: 2,
    high: 3,
  };
  let worst: string | null = null;
  for (const tier of [primary, secondary, tertiary]) {
    if (!tier) continue;
    if (worst === null || (TIER_RANK[tier] ?? 99) < (TIER_RANK[worst] ?? 99)) {
      worst = tier;
    }
  }
  return worst;
}
